import React from 'react';
import {DragHandle} from './DragHandle';
import styled from 'styled-components';

const StyledStaticData = styled.td`
  &:first-of-type {
    min-width: auto;
  }
`;

const StyledStaticTableRow = styled.tr`
  box-shadow: rgb(0 0 0 / 10%) 0px 20px 25px -5px,
    rgb(0 0 0 / 30%) 0px 10px 10px -5px;
  outline: #ebedf2 solid 1px;
`;

export const StaticTableRow = ({row}) => {
  return (
    <StyledStaticTableRow {...row.getRowProps()}>
      {row.cells.map((cell, i) => {
        if (i === 0) {
          return (
            <StyledStaticData {...cell.getCellProps()}>
              <DragHandle isDragging />
              <span>{cell.render('Cell')}</span>
            </StyledStaticData>
          );
        }
        return (
          <StyledStaticData {...cell.getCellProps()}>
            {cell.render('Cell')}
          </StyledStaticData>
        );
      })}
    </StyledStaticTableRow>
  );
};
